import { ValueOf } from "@/types/type";

export const SCORM_VERSION = {
  SCORM_1_2: "1.2",
  SCORM_2004: "2004",
} as const;
export type ScormVersion = ValueOf<typeof SCORM_VERSION>;

export const DEFAULT_SCORM_VERSION = SCORM_VERSION.SCORM_1_2;
export const DEFAULT_SCORM_COMPLETION_CRITERIA = 80;
export const MIN_SCORM_COMPLETION_CRITERIA = 10;
export const MAX_SCORM_COMPLETION_CRITERIA = 100;
